<script setup lang="ts">
// eslint-disable-next-line import/no-extraneous-dependencies
import { ref, inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { Typography, TextLink } from '@temperworks/components'
import { TypographyType, IconPosition, IconNames, IconSizes, IconColors, IconInterface } from '@temperworks/types'
import { TemperIcon } from '@temperworks/icons'

const windowSize = ref < number >(window.innerWidth)
const navigate: Function = inject('navigate')
const { t } = useI18n()
const icon = ref < IconInterface >({
  name: IconNames.arrowRight,
  color: IconColors.purple500,
  position: IconPosition.right,
  size: IconSizes.standard
})
function goTo() {
  navigate('/platform-guide')
}

const imgUrl = new URL('../../../../public/images/learning-desktop.png', import.meta.url).href

</script>

<template>
  <div class="help-footer">
    <img
      v-if="(windowSize > 992)"
      :src="imgUrl"
      class="help-image"
    >
    <TemperIcon
      v-else
      :name="IconNames.idea"
      position="center"
    />
    <div class="help-footer-content">
      <Typography
        :variant="TypographyType.h3"
        :content="t('dashboard.staticDashboard.footer.header')"
      />
      <div
        class="help-description"
        :class="{ 'no-link': windowSize > 992 }"
      >
        <Typography
          :variant="TypographyType.bodySmall"
          :content="t('dashboard.staticDashboard.footer.description_0')"
        />
        <TextLink
          :variant="TypographyType.bodySmall"
          :link-text="t('dashboard.staticDashboard.footer.platformGuide')"
          @clicked="goTo()"
        />
        <Typography
          :variant="TypographyType.bodySmall"
          :content="t('dashboard.staticDashboard.footer.description_1')"
        />
      </div>
      <div
        v-if="(windowSize > 992)"
        class="help-link"
      >
        <TextLink
          :variant="TypographyType.body"
          :link-text="t('dashboard.staticDashboard.footer.button')"
          :icon="icon"
          @clicked="goTo()"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use './HelpFooter.scss';
</style>
